import index from '@/views/index';
import login from '../views/login/login';
import register from "../views/login/register";
import registerSuccess from "../views/login/registerSuccess";
import companyRegister from "../views/login/companyRegister";
import registerDetail from "../views/login/registerDetail";
import retrievePassword from "../views/login/retrievePassword";
import test from "@/views/test";
import notice from "../views/notice";
import forum from "../views/forum";
import bulletin from "../views/bulletin";
import aboutUs from "../views/aboutUs";
import bulletinDetail from "../views/bulletinDetail";
import statementDetail from "@/views/account/statementDetail";
import boxApplyForm from "../views/order/boxApplyForm";
import indentDetail from "@/views/order/indentDetail";
import orderDetail from "@/views/order/orderDetail";
import activityOrder from "@/views/order/activityOrder";
import historyOrder from "@/views/order/historyOrder";
import cancelOrder from "@/views/order/cancelOrder.vue";
import home from "../views/company/home";
import enterprise from "../views/company/enterprise"
import userEdit from "@/views/company/userEdit";
import companyEdit from "@/views/company/companyEdit";
import bankInfoEdit from "@/views/company/bankInfoEdit";
import helpCenter from "@/views/help/helpCenter";
import helpDetails from "@/views/help/helpDetails";

//------------------------------------- 公共模块 -------------------------------------//
import notFound from '../views/notFound';

export default {
  routes: [
    { path: '/', name: 'index', component: index },
    { path: '/index', name: 'index', component: index },
    { path: '/test', name: 'test', component: test },
    { path: '/bulletin', name: 'bulletin', component: bulletin },
    { path: '/bulletinDetail', name: 'bulletinDetail', component: bulletinDetail },
    { path: '/login', name: 'login', component: login },
    { path: '/notice', name: 'notice', component: notice },
    { path: '/register', name: 'register', component: register },
    { path: '/registerSuccess', name: 'registerSuccess', component: registerSuccess },
    { path: '/retrievePassword', name: 'retrievePassword', component: retrievePassword },
    { path: '/registerDetail', name: 'registerDetail', component: registerDetail },
    // { path: '/forum', name: 'forum', component: forum }, // 供需论坛，未开发
    { path: '/test', name: 'test', component: test },
    { path: '/company/home', name: 'home', component: home },
    { path: '/companyDetails', name: 'companyDetails', component: registerDetail },
    { path: '/companyRegister', name: 'companyRegister', component: companyRegister },
    { path: '/company/enterprise', name: 'enterprise', component: enterprise },
    { path: '/company/userEdit', name: 'userEdit', component: userEdit },
    { path: '/company/companyEdit', name: 'companyEdit', component: companyEdit },
    { path: '/company/bankInfoEdit', name: 'bankInfoEdit', component: bankInfoEdit},
    { path: '/order/boxApplyForm', name: 'boxApplyForm', component: boxApplyForm },
    { path: '/order/indentDetail', name: 'indentDetail', component: indentDetail },
    { path: '/order/orderDetail', name: 'orderDetail', component: orderDetail },
    { path: '/order/activityOrder', name: 'activityOrder', component: activityOrder },
    { path: '/order/historyOrder', name: 'historyOrder', component: historyOrder },
    { path: '/order/activityOrder', name: 'activityOrder', component: activityOrder },
    { path: '/order/cancelOrder', name: 'cancelOrder', component: cancelOrder },
    { path: '/aboutUs', name: 'aboutUs', component: aboutUs },
    { path: '/account/statementDetail', name: 'statementDetail', component: statementDetail},
    { path: '/help/helpCenter', name: 'helpCenter', component: helpCenter},
    { path: '/help/helpDetails', name: 'helpDetails', component: helpDetails},
    // ...routeConfig_system,
    // ...routeConfig_tenant,

    { path: '*', name: 'notFound', component: notFound },
  ],

  authType: 'white',  //白名单 white 可以跳过登录 | 黑名单 black 不可以跳过登录
  whiteList: [
    /^\/$/,
    /^\/index$/,
    /^\/login/,
    /^\/403/,
    /^\/register$/,
    /^\/retrievePassword/,
    /^\/registerSuccess/ ,
    // /^\/forum/, // 供需论坛，未开发
    /^\/test/,
    /^\/help/,
    /^\/aboutUs/,
  ],
  companyUnapprovedList: [
    /^\/registerDetail/,
    /^\/companyRegister/,
    /^\/registerSuccess/,
  ],

  blackList: [],
};
